import commonUtils from '@/school-management/utils/common';
import { GroupReportItem } from '@/school-management/types/response';
import type { TeacherGroup } from '@/types/user';

export type ClassesReportTableRow = {
  id: string;
  name: string;
  teachers: GroupReportItem['teachers'];
  teacher: string;
  grade: string;
  gradeId: number | null | undefined;
  students: number;
  activeStudents: number;
  percentageOfActiveStudents: number;
  classCode?: string | null;
};

export function formatTeacherNamesFromReport(teachers: GroupReportItem['teachers']): string {
  if (!Array.isArray(teachers) || teachers.length === 0) return '';
  return teachers
    .map(te => {
      const first = te?.firstName ?? '';
      const last = te?.lastName ?? '';
      return [first, last].filter(Boolean).join(' ');
    })
    .filter(Boolean)
    .join(', ');
}

export function normalizeGroupReportItemsToTableRows(
  classesList: GroupReportItem[],
  t: (key: string) => string
): ClassesReportTableRow[] {
  return (classesList || []).map(c => {
    const grade = commonUtils.getGradeName(c.gradeId, t);
    const percentageOfActiveStudents = commonUtils.getPercentageOfActiveStudents(
      c.numberOfStudents,
      c.numberOfActiveStudents
    );

    return {
      id: c.groupId,
      name: c.groupName,
      teachers: c.teachers,
      teacher: formatTeacherNamesFromReport(c.teachers),
      grade,
      gradeId: c.gradeId,
      students: c.numberOfStudents,
      activeStudents: c.numberOfActiveStudents,
      percentageOfActiveStudents,
      classCode: c.classCode,
    };
  });
}

/** Map API row to TeacherGroup for existing my-classes flows (grade as numeric string). */
export function classesReportTableRowToTeacherGroup(row: ClassesReportTableRow): TeacherGroup {
  const gradeStr =
    row.gradeId !== null && row.gradeId !== undefined ? String(row.gradeId) : row.grade || '';

  return {
    id: row.id,
    name: row.name,
    grade: gradeStr,
    totalStudents: row.students,
    ...(row.classCode ? { classCode: row.classCode } : {}),
  };
}
